import { Injectable, OnInit } from '@angular/core';
import * as firebase from 'firebase/app';
import 'firebase/remote-config';
import { Observable } from 'apollo-link';
import {SessionService} from '../Session/session-service.service';
import {Subject} from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class FirebaseService implements OnInit {
  private _fcmToken = new Subject();
  fcmToken$ = this._fcmToken.asObservable();
  constructor(private sessionService: SessionService) {
  }

  public stringRc: string;
  remoteConfig = firebase.remoteConfig();
  //messaging = firebase.messaging();
  // tslint:disable-next-line:contextual-lifecycle
  ngOnInit(): void {
    this.fetchActivate().then(r => {});
  }
  fetchActivate() {
    console.log("entra a fetchActivate");
    this.remoteConfig = firebase.remoteConfig();
    this.remoteConfig.settings.minimumFetchIntervalMillis = 36000;
    return this.remoteConfig.fetchAndActivate();
  }
 getStringRC(str: string): string {
    this.stringRc = this.remoteConfig.getString(str);
    return this.remoteConfig.getString(str).toString();
  }
  getMessagin() {
    /*
    if (firebase.messaging.isSupported()) {
      this.messaging = firebase.messaging();
      try {
        this.messaging.usePublicVapidKey('BHzgwyzQc3KRvlToHyZPl8cOOKpZ1qbSZtB2-S6EjHoBxd-KZVrfdK6sdns6kWkEKB1QBRNq4uwlu_ZnBoXjX9E');
      } catch {
        console.log('used once');
      }
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          console.log('Notification permission granted.');
          this.getToken();
          // TODO(developer): Retrieve an Instance ID token for use with FCM.
          // ...
        } else {
          console.log('Unable to get permission to notify.');
        }
      });
    }*/
  }
  getToken() {
    /*
    // Get Instance ID token. Initially this makes a network call, once retrieved
// subsequent calls to getToken will return from cache.
    this.messaging.getToken().then((currentToken) => {
      if (currentToken) {
        console.log('Curr token: ', currentToken);
        this.sessionService.saveParam('fcmToken', currentToken.toString());
        this._fcmToken.next(currentToken);
        // sendTokenToServer(currentToken);
        // updateUIForPushEnabled(currentToken);
      } else {
        // Show permission request.
        console.log('No Instance ID token available. Request permission to generate one.');
        // Show permission UI.
        // updateUIForPushPermissionRequired();
        // setTokenSentToServer(false);
      }
    }).catch((err) => {
      console.log('An error occurred while retrieving token. ', err);
      // showToken('Error retrieving Instance ID token. ', err);
      // setTokenSentToServer(false);
    });
    // Callback fired if Instance ID token is updated.
    this.messaging.onTokenRefresh(() => {
      this.messaging.getToken().then((refreshedToken) => {
        console.log('Token refreshed.', refreshedToken);
        this.sessionService.saveParam('fcmToken', refreshedToken);
        this._fcmToken.next(refreshedToken.toString());
        // Indicate that the new Instance ID token has not yet been sent to the
        // app server.
        // setTokenSentToServer(false);
        // Send Instance ID token to app server.
        // sendTokenToServer(refreshedToken);
        // ...
      }).catch((err) => {
        console.log('Unable to retrieve refreshed token ', err);
        // showToken('Unable to retrieve refreshed token ', err);
      });
    });
*/
  }
}
